module.exports = __webpack_public_path__ + "static/img/image.d21ebb64.png";